import { serviceMaker, methods, api } from "./index.js";

export const getEntities = () =>
  serviceMaker(`/offices/officesView`, methods.GET, api.NGB);
export const getEntityTemplate = () =>
  serviceMaker("/offices/template", methods.GET, api.NGB);
export const createEntity = (data) =>
  serviceMaker("/offices", methods.POST, api.NGB, data);
export const getEntityById = (id) =>
  serviceMaker(`/offices/${id}`, methods.GET, api.NGB);
export const getEntityTickets = (entityId) =>
  serviceMaker(`/tickets/office/${entityId}`, methods.GET, api.NGB);
export const getTicketTemplate = () =>
  serviceMaker(`/tickets/template`, methods.GET, api.NGB);
export const deleteTickets = (entityId) =>
  serviceMaker(`/tickets/office/${entityId}`, methods.DELETE, api.NGB);
export const cerateTickets = (entityId, data) =>
  serviceMaker(`/tickets/office/${entityId}`, methods.POST, api.NGB, data);
export const cerateTicketsDocument = (entityId, data) =>
  serviceMaker(
    `/officeTicket/${entityId}/documents`,
    methods.POST,
    api.NGB,
    data
  );
export const createAgreement = (payload) =>
  serviceMaker(
    `/agreements`,
    methods.POST,
    api.NGB,
    payload
  );
export const getAgreements = (id) =>
  serviceMaker(`/agreements/${id}`, methods.GET, api.NGB );

export const uploadCompanyLogo = (entityId, data) =>
  serviceMaker(
    `/companyLogo/${entityId}/documents`,
    methods.POST,
    api.NGB,
    data
  );

// customer
export const getEntityCustomers = (entityId) =>
  serviceMaker(`/lco/${entityId}`, methods.GET, api.NGB);
// city templete
export const getCityTemplate = (city) =>
  serviceMaker(`/address/template/${city}`, methods.GET, api.NGB);
export const updateEntity = (id, data) =>
  serviceMaker(`/offices/${id}`, methods.PUT, api.NGB, data);
export const updateCreditLimit = (id, data) =>
  serviceMaker(
    `/officeadjustments/updateCreditLimit/${id}`,
    methods.PUT,
    api.NGB,
    data
  );
export const getAdjustmentsTemplate = () =>
  serviceMaker("/officeadjustments/template", methods.GET, api.NGB);
export const getDisbursements = (eName) =>
  serviceMaker(
    `/patnerdisbursement?limit=14&offset=0&partnerType=${eName}`,
    methods.GET,
    api.NGB
  );
export const getTransactions = (id) =>
  serviceMaker(`/offices/financialtransactions/${id}`, methods.GET, api.NGB);
export const getAgreementsTemplate = () =>
  serviceMaker(`/agreements/template`, methods.GET, api.NGB);
export const createAdjustment = (id, data) =>
  serviceMaker(`/officeadjustments/${id}`, methods.POST, api.NGB, data);
export const getPaymentsTemplate = () =>
  serviceMaker(`/officepayments/template`, methods.GET, api.NGB);
export const createPayments = (id, data) =>
  serviceMaker(`/officepayments/${id}`, methods.POST, api.NGB, data);
export const cancelRemark = (id, data) =>
  serviceMaker(
    `/officepayments/cancelofficepayment/${id}`,
    methods.PUT,
    api.NGB,
    data
  );
export const renewal = (data) =>
  serviceMaker(`/lco/renewal`, methods.PUT, api.NGB, data);
export const downloadTicketDocument = (entityId, documentId) =>
  serviceMaker(
    `/officeTicket/${entityId}/documents/attachment/${documentId}`,
    methods.GET,
    api.NGB
  );
export const getEditTicketTemplate = (entityId, ticketId) =>
  serviceMaker(
    `/tickets/office/${entityId}/${ticketId}?template=true`,
    methods.GET,
    api.NGB
  );
export const updateTicket = (id, data) =>
  serviceMaker(`/tickets/office/${id}`, methods.PUT, api.NGB, data);
export const cancelTicket = (id, data) =>
  serviceMaker(`/tickets/office/close/${id}`, methods.PUT, api.NGB, data);
export const cancelTicketTemplate = () =>
  serviceMaker(
    `/tickets/template?templateFor=closeticket`,
    methods.GET,
    api.NGB
  );
export const viewTicketData = (entityId, id) =>
  serviceMaker(`/tickets/office/${entityId}/${id}`, methods.GET, api.NGB);
